import HomeRoll from './HomeRoll'

export default HomeRoll


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/HomeRoll/index.ts